import type { Me } from '@portal/contracts';
import { LayoutGrid, Plus, SlidersHorizontal } from 'lucide-react';

const DATE = new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Berlin' });

/**
 * Arbeitsplatz (DESIGN.md § 11/4.2): Titel, Datum, „Deine persönliche Übersicht", rechts Anpassen + Widget hinzufügen.
 * Widgets (Katalog, Speicherung je Person) folgen als eigener Baustein; eine leere Übersicht ist laut § 5.2 erlaubt.
 */
export function Arbeitsplatz({ me }: { me: Me }) {
  return (
    <section className="ap">
      <div className="ap-head">
        <div>
          <h1 className="ap-title">Arbeitsplatz</h1>
          <p className="ap-sub">
            {DATE.format(new Date())} · Deine persönliche Übersicht
          </p>
        </div>
        <div className="ap-actions">
          <button type="button" className="pb-button pb-button--quiet" disabled title="Folgt mit dem Widget-Baustein">
            <SlidersHorizontal size={15} aria-hidden /> Anpassen
          </button>
          <button type="button" className="pb-button" disabled title="Folgt mit dem Widget-Baustein">
            <Plus size={15} aria-hidden /> Widget hinzufügen
          </button>
        </div>
      </div>
      <p className="ap-role">Ansicht: {me.roles.join(', ')}</p>
      <div className="ap-grid">
        <div className="pb-card ap-empty">
          <LayoutGrid size={18} aria-hidden />
          <div>
            <h2>Noch keine Widgets</h2>
            <p>Der Widget-Katalog folgt mit den Fachmodulen. Deine Module erreichst du über die Navigation.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
